import Uri from "jsuri";
import type { IMarketingBlocksResponse } from "../constants/apiconstants-drupal";
import Env from "../utils/env";
import { getUri } from "../utils/fetch";

export const getMarketingBlocks = (abortSignal?: AbortSignal): Promise<IMarketingBlocksResponse> => {
	const additionalParams: RequestInit = {};
	const uri = new Uri(`${Env.ConnectPortalUrls[Env.getEnvName()]}en/mkt-app/dashboard-contents`);
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	return getUri(uri, additionalParams);
};
